var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2918)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90323 6.06329C6.90323 4.38546 8.2897 3.02532 10 3.02532C11.7103 3.02532 13.0968 4.38546 13.0968 6.06329V10.1139H6.90323V6.06329ZM10 1C7.1495 1 4.83871 3.26691 4.83871 6.06329V10.3671H2.77419C2.34662 10.3671 2 10.7071 2 11.1266V18.7215C2 19.9799 3.03985 21 4.32258 21H15.6774C16.9601 21 18 19.9799 18 18.7215V11.1266C18 10.7071 17.6534 10.3671 17.2258 10.3671H15.1613V6.06329C15.1613 3.26691 12.8505 1 10 1ZM10 13.1519C10.8552 13.1519 11.5484 13.832 11.5484 14.6709C11.5484 15.2429 11.2261 15.7411 10.7499 16.0002C10.7657 16.0608 10.7742 16.1244 10.7742 16.1899V18.2152C10.7742 18.6346 10.4276 18.9747 10 18.9747C9.57242 18.9747 9.22581 18.6346 9.22581 18.2152V16.1899C9.22581 16.1244 9.23426 16.0608 9.25015 16.0002C8.77394 15.7411 8.45161 15.2429 8.45161 14.6709C8.45161 13.832 9.14485 13.1519 10 13.1519Z",
    fill: "#329DFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2918",
    x: 0,
    y: 0,
    width: 20,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2918",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockDisabled);
export default __webpack_public_path__ + "static/media/lock_disabled.c6437acbfeffd8b23b427cf87347cf73.svg";
export { ForwardRef as ReactComponent };